import { render, staticRenderFns } from "./RfqStatusReport.vue?vue&type=template&id=468c3428&scoped=true"
import script from "./RfqStatusReport.vue?vue&type=script&lang=js"
export * from "./RfqStatusReport.vue?vue&type=script&lang=js"
import style0 from "./RfqStatusReport.vue?vue&type=style&index=0&id=468c3428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c3428",
  null
  
)

export default component.exports